export interface MedicalProfessional {
  id: string;
  name: string;
  specialty: string;
  crm: string;
  bio: string;
  photo: string;
  availableDays: string[];
}

export interface ClinicService {
  id: string;
  title: string;
  description: string;
  duration: string;
  icon: string;
}

export const clinicaProfissionais: MedicalProfessional[] = [
  {
    id: 'med_001',
    name: 'Dr. Roberto Almeida',
    specialty: 'Implantodontia e Estética',
    crm: 'CRO-PR 12345',
    bio: 'Especialista em reabilitação oral e estética dental com mais de 15 anos de experiência.',
    photo: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?q=80&w=400&auto=format&fit=crop',
    availableDays: ['Segunda', 'Quarta', 'Sexta']
  },
  {
    id: 'med_002',
    name: 'Dra. Camila Costa',
    specialty: 'Ortodontia Invisalign',
    crm: 'CRO-PR 54321',
    bio: 'Referência em alinhadores invisíveis e tratamentos ortodônticos avançados.',
    photo: 'https://images.unsplash.com/photo-1594824436998-058b2315530d?q=80&w=400&auto=format&fit=crop',
    availableDays: ['Terça', 'Quinta']
  },
  {
    id: 'med_003',
    name: 'Dr. Thiago Marques',
    specialty: 'Cirurgia Bucomaxilofacial',
    crm: 'CRO-PR 98765',
    bio: 'Mestre em cirurgias complexas, remoção de sisos e enxertos ósseos.',
    photo: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=400&auto=format&fit=crop',
    availableDays: ['Quarta', 'Sexta']
  }
];

export const clinicaServicos: ClinicService[] = [
  {
    id: 'srv_001',
    title: 'Lentes de Contato',
    description: 'Transformação do sorriso com facetas ultrafinas de porcelana.',
    duration: '1h 30m',
    icon: 'smile'
  },
  {
    id: 'srv_002',
    title: 'Implantes Dentários',
    description: 'Reabilitação oral segura com os melhores implantes do mercado.',
    duration: '2h',
    icon: 'shield'
  },
  {
    id: 'srv_003',
    title: 'Invisalign',
    description: 'Tratamento ortodôntico invisível, rápido e confortável.',
    duration: '45m',
    icon: 'sparkles'
  },
  {
    id: 'srv_004',
    title: 'Clareamento a Laser',
    description: 'Resultados imediatos para um sorriso mais branco e iluminado.',
    duration: '1h',
    icon: 'sun'
  }
];
